export const API = {
    GET_VENDOR_LIST: '/api/v1/VendorMaster/GetAllVendorMaster',
    CREATE_VENDOR: '/api/v1/VendorMaster/InsertVendorMaster',
    GET_VENDOR_BY_ID: '/api/v1/VendorMaster/GetVendorMaster',
    UPDATE_VENDOR: '/api/v1/VendorMaster/UpdateVendorMaster',
    GET_VENDOR_BY_MOBILE_NO: '/api/v1/VendorMaster/GetVendorMasterByMobileNo',
    DELETE_VENDOR: '/api/v1/VendorMaster/DeleteVenderMasterById',
}